import React from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import Panel from '../components/Panel';
import StatCard from '../components/StatCard';
import { IconSliders, IconTrendUp, IconBus } from '../components/icons';

const PRIO = { haute: 'tag--red', moyenne: 'tag--amber', basse: 'tag--slate' };

export default function Optimizer() {
  const { loading, data, live } = useApi(() => api.optimizer());
  const recs = data?.recommandations || [];
  const gain = data ? data.couverture_optimisee - data.couverture_actuelle : 0;

  return (
    <>
      <Topbar title="Optimiseur de lignes & de flottes" subtitle="Recommandation de tracés et fréquences" live={live} />
      <div className="content">
        {loading ? <div className="loading-screen">Chargement…</div> : (
          <>
            <div className="kpi-row kpi-row--3">
              <StatCard label="Couverture actuelle" value={`${data.couverture_actuelle}`} unit="%" icon={IconBus} delay={0} />
              <StatCard label="Couverture optimisée" value={`${data.couverture_optimisee}`} unit="%" icon={IconTrendUp} trend={{ dir: 'up', text: `+${gain} points` }} delay={70} />
              <StatCard label="Actions proposées" value={String(recs.length)} icon={IconSliders} delay={140} />
            </div>
            <Panel icon={IconSliders} title="Recommandations" sub="Tracés & fréquences proposés" badge={`${recs.length} actions`} delay={120}>
              <table className="tbl">
                <thead><tr><th>Action</th><th>Tracé</th><th className="num">Demande couverte</th><th className="num">Fréq.</th><th>Bénéfice</th><th>Priorité</th></tr></thead>
                <tbody>
                  {recs.map((r, i) => (
                    <tr key={i}>
                      <td><b>{r.ligne}</b></td>
                      <td>{r.trace}</td>
                      <td className="num mono">{r.demande_couverte.toLocaleString('fr-FR')}</td>
                      <td className="num mono">{r.frequence_min}′</td>
                      <td>{r.gain}</td>
                      <td><span className={`tag ${PRIO[r.priorite]}`}>{r.priorite}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Panel>
          </>
        )}
      </div>
    </>
  );
}
